import { useState, useEffect } from "react";
import { ListTablePaginated } from "src/general_components/ListTablePaginated";
import { Grid, useTheme, useMediaQuery, Button } from "@mui/material";
import { GenericCard } from "src/general_components/GenericCard";
import { FormularioDinamicoModelos } from "src/general_components/FormularioDinamicoModelos";
import { getTablaEstructura, getDataSelect } from "src/hooks/structureTable";
import { PageHeaderCard } from "src/general_components/PageHeaderCard";
import ViewModuleIcon from "@mui/icons-material/ViewModule";
import { getEstantesUbicaciones, getEstantesUbicacionesPaginated, setEstantes } from "../helpers/EstantesData";

export const EstantesUbicaciones = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    const [createButton, setCreateButton] = useState(false);
    const [dataEdit, setDataEdit] = useState([]);
    // eslint-disable-next-line no-unused-vars
    const [columns, setColumns] = useState([]);
    const [formData, setFormData] = useState({});
    const [options, setOptions] = useState({});
    const [columnsLoaded, setColumnsLoaded] = useState(false);
    const columnasAexcluir = false;
    const valuesDefaultForm = false;
    const columnasAdicional = [];
    const condiciones = false;
    const condiciones_select = false;
    const joins = false;
    const modelo = "estantes";
    const filtros = {
        modelo: modelo,
        condiciones: condiciones,
        joins: joins
    }

    const toPascalCase = (str) => {
        return str
            .replace(/_/g, ' ')  // Reemplaza guiones bajos con espacios
            .replace(/\b\w+/g, (word) => word[0].toUpperCase() + word.slice(1).toLowerCase());  // Convierte la primera letra de cada palabra a mayúscula
    };

    // Ejemplo de uso:
    const listName = "Administracion de Estantes" || toPascalCase(modelo);

    useEffect(() => {
        const filtrarCampos = async (formDataResponse) => {
            const camposFiltrados = {};

            for (const fieldName in formDataResponse) {
                if (fieldName.includes('id_')) {
                    const palabraExtraida = fieldName.replace('id_', '');
                    const valorLocalStorage = JSON.parse(localStorage.getItem("siam-" + palabraExtraida))?.[palabraExtraida];

                    if (valorLocalStorage) {
                        const opcionesFiltradas = valorLocalStorage.map(({ id, nombre, descripcion, label, detalle }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || 'Sin Nombre',
                        }));

                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    } else {
                        let condiciones_where = [];

                        for (const key in condiciones_select) {
                            if (key.includes(palabraExtraida)) {
                                console.log("entreee", condiciones_select[key]);

                                condiciones_select[key].forEach(obj => {
                                    console.log("obj", obj);

                                    // Iterar sobre las propiedades del objeto
                                    for (const propiedad in obj) {
                                        condiciones_where.push({
                                            campo: propiedad,
                                            valor: obj[propiedad],
                                            operador: " = "
                                        });
                                    }
                                });
                            }
                        }

                        console.log('condiciones_where', condiciones_where);

                        const datosSelect = await getDataSelect(palabraExtraida, condiciones_where);
                        const opcionesFiltradas = datosSelect.map(({ id, nombre, descripcion, label, detalle }) => ({
                            id,
                            nombre: nombre || descripcion || detalle || label || 'Sin Nombre',
                        }));
                        console.log("opcionesFiltradas", opcionesFiltradas)
                        camposFiltrados[fieldName] = {
                            ...formDataResponse[fieldName],
                            options: opcionesFiltradas,
                        };
                    }
                }
            }

            let camposFinal = { ...formDataResponse, ...camposFiltrados };

            if (camposFinal.id) {
                delete camposFinal.id;
            }

            return camposFinal;
        };

        const getEstructuraTabla = async () => {
            // await getEstantesUbicaciones();
            let response = await getTablaEstructura(modelo);

            if (response.status === "true") {
                const formDataResponse = response.wsResponse;
                const campos = await filtrarCampos(formDataResponse);
                let camposFiltrados = campos;
                if (columnasAexcluir) {
                    camposFiltrados = Object.fromEntries(
                        Object.entries(campos).filter(([key]) => !columnasAexcluir.includes(key))
                    );
                }

                const generatedColumns = Object.keys(camposFiltrados).slice(0, 5).map((field, index) => {
                    const label = camposFiltrados[field].label;
                    const headerName = typeof label === 'object' && Object.keys(label).length === 0
                        ? field.charAt(0).toUpperCase() + field.slice(1)
                        : label || field.charAt(0).toUpperCase() + field.slice(1);

                    const column = {
                        field: field,
                        headerName: headerName,
                        flex: 1,
                        align: 'center',
                        headerAlign: "center",
                    };

                    // Check if the field is "activo" to apply custom rendering
                    if (field === 'activo') {
                        column.flex = 0.2;
                        column.renderCell = (params) => (params.value === "1" ? 'Sí' : 'No');
                    }

                    return column;
                });

                const columnasGeneradas = [{
                    field: "id",
                    headerName: "ID",
                    flex: 0.1, // Divide equitativamente entre el número de columnas
                }, ...generatedColumns, ...columnasAdicional
                ];

                setColumns(columnasGeneradas);
                if (valuesDefaultForm) {
                    // Eliminar propiedades de camposFinal si coinciden con valuesDefaultForm
                    Object.keys(valuesDefaultForm).forEach((key) => {
                        delete campos[key];
                    });
                }
                setFormData(campos);
                setOptions({
                    cols: columnasGeneradas,
                    get: getEstantesUbicaciones,
                    getPaginated: getEstantesUbicacionesPaginated,
                    pageSize: [5, 10, 25],
                    edit: true,
                    // delete: deleteDataById,
                    limit: 50,
                    filter: true,
                    exportData: true,
                    server: true,
                    createButton: createButton,
                    setCreateButton: setCreateButton,
                    setDataEdit: setDataEdit,
                    idElementData: filtros,
                    mobileComponent: ({ row }) => (
                        <GenericCard
                            row={row}
                            columns={columnasGeneradas}
                            onEdit={(item) => {
                                setDataEdit(item);
                                setCreateButton(true);
                            }}
                        />
                    )
                });
                setColumnsLoaded(true); // Indicar que las columnas se han cargado
            }
        };

        getEstructuraTabla();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [modelo]);

    if (createButton === false && dataEdit.id !== undefined) {
        setDataEdit([]);
    }

    const mobileTopButtons = isMobile && (
        <Grid container justifyContent="flex-end" mb={2} mt={1}>
            <Grid item xs={12} sm={6}>
                <Button
                    fullWidth
                    variant="contained"
                    color="primary"
                    onClick={() => { setCreateButton(true); setDataEdit([]); }}
                    style={{ fontSize: "11px", height: "30px", fontFamily: 'Roboto, sans-serif', color: '#FFFFFF' }}
                >
                    Añadir Estante
                </Button>
            </Grid>
        </Grid>
    );

    return (
        <Grid style={{ marginBottom: "50px", backgroundc: "rgb(241, 243, 244)", paddingTop: 10 }}>
            <PageHeaderCard title={listName} icon={<ViewModuleIcon />} />
            {mobileTopButtons}

            {columnsLoaded && (
                <>
                    <ListTablePaginated options={options} />
                    <FormularioDinamicoModelos
                        data={dataEdit}
                        createButton={createButton}
                        listName={listName}
                        setCreateButton={setCreateButton}
                        setOptions={setOptions}
                        options={options}
                        formData={formData}
                        modelo={modelo}
                        dataDefault={valuesDefaultForm}
                        functionInsertUpdate={setEstantes}
                    />
                </>
            )}
        </Grid>
    );
};
